<template>
  <div class="border-top">
    <SOFilterTitle :title="'Kategori Mesin'" :id="id"/>
    <div class="p-l-24 p-r-24 p-d-24" :id="id">
      <SOInputCheckbox
          :checkboxes="kategoriData"
          :checked="filterItem.kategoriMesin"
          @selected="selected"
      />
    </div>
  </div>
</template>

<script>
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";
import {mapGetters} from "vuex";

export default {
  name: "SOFilterKategoriMesin",
  components: {
    SOFilterTitle,
    SOInputCheckbox,
  },
  props: {
    id: String,
  },
  data() {
    return {
      kategoriData: {
        name: "kategori-mesin",
        data: []
      },
    }
  },
  methods: {
    selected(val) {
      let temp = this.filterItem
      temp.kategoriMesin = val
      this.$store.commit("filterGlobalModule/setFilterItem", temp)
    },
    async tagMesin() {
      const res = await this.$store.dispatch("snapMesinModule/fetchTagMesin", this.$route.query.idoutlet)
      if (res.success) {
        for (let i = 0; i < this.listTagMesin.data.length; i++) {
          this.kategoriData.data.push({
            id: "fkmesin-" + i,
            value: this.listTagMesin.data[i].id,
            title: this.listTagMesin.data[i].nama,
            cheked: false,
            titleBold: false
          })
        }
      } else {
        this.$toast.error(res.err)
      }
    },
  },
  mounted() {
    this.tagMesin()
  },
  computed: {
    ...mapGetters("filterGlobalModule", {
      filterItem: "getFilterItem"
    }),
    ...mapGetters("snapMesinModule", {
      listTagMesin: "getListTagMesin",
    })
  },
}
</script>